import { Button, TextField } from "@mui/material";
import ExpandableComponent from "../mui/expandableComponent";
import { Save } from "@mui/icons-material";
import { useState } from "react";
import { updateAgentInfo, updateFaqsInfo, updateKitchenInfo, updateUserInfo } from "../data/API";

export default function Information({ data ,setLoading,setWarning}) {
  const [copyUserInfoData, setUserInfoData] = useState(data?.user);
  const [copyKitchenInfoData, setKitchenInfoData] = useState(data?.kitchen);
  const [copyAgentInfoData, setAgentInfoData] = useState(data?.agent);
  const [copyFaqInfoData, setFaqInfoData] = useState(data?.faqs);

  function updateKictenData(dataArray) {
    //make network call
    console.log("updatedData:", dataArray);
     //make network call
     setLoading(true);
     setWarning(false);
     updateKitchenInfo(dataArray,(err,d)=>{
       if(err){
         setLoading(false);
         setWarning(true);
       }else{
         setLoading(false);
         setWarning(false);
         setKitchenInfoData(d);
       }
     })
  }

  function updateAgentData(dataArray) {
    //make network call
    console.log("updatedData:", dataArray);
    setLoading(true);
    setWarning(false);
    updateAgentInfo(dataArray,(err,d)=>{
      if(err){
        setLoading(false);
        setWarning(true);
      }else{
        setLoading(false);
        setWarning(false);
        setAgentInfoData(d);
      }
    })
  }

  function updateUserData(dataArray) {
    //make network call
    console.log("updatedData:", dataArray);
    setLoading(true);
    setWarning(false);
    updateUserInfo(dataArray,(err,d)=>{
      if(err){
        setLoading(false);
        setWarning(true);
      }else{
        setLoading(false);
        setWarning(false);
        setUserInfoData(d);
      }
    })
  }

  function updateFaqsData(dataArray) {
    //make network call
    console.log("updatedData:", dataArray);
    setLoading(true);
    setWarning(false);
    updateFaqsInfo(dataArray,(err,d)=>{
      if(err){
        setLoading(false);
        setWarning(true);
      }else{
        setLoading(false);
        setWarning(false);
        setFaqInfoData(d);
      }
    })
  }
  

  return (
    <div className="pt-3  gap-5 flex flex-col  px-1 pb-1">
      <ExpandableComponent
        title={"Kitchen Registeration"}
        Child={
          <div className="flex flex-col gap-4 mt-2">
            {copyKitchenInfoData?.map((element, i) => {
              return (
                <div>
                  <TextField
                    label={element.name}
                    placeholder="Type Value"
                    multiline
                    rows={2}
                    fullWidth
                    defaultValue={element.value}
                    onChange={(e) => {
                      copyKitchenInfoData[i].value = e.target.value;
                    }}
                  />
                </div>
              );
            })}

            <Button
              onClick={() => {
                updateKictenData(copyKitchenInfoData);
              }}
              color={"success"}
              variant="contained"
              sx={{ paddingX: "13px", width: "100px" }}
            >
              Save <Save sx={{ marginInlineStart: "10px" }} />
            </Button>
          </div>
        }
      />
      <ExpandableComponent
        title={"Edit Menu (User)"}
        Child={
          <div className="flex flex-col gap-4 mt-2">
            {copyUserInfoData?.map((element, i) => {
              return (
                <div>
                  <TextField
                    label={element.name}
                    placeholder="Type Value"
                    multiline
                    rows={2}
                    fullWidth
                    defaultValue={element.value}
                    onChange={(e) => {
                      copyUserInfoData[i].value = e.target.value;
                    }}
                  />
                </div>
              );
            })}

            <Button
              onClick={() => {
                updateUserData(copyUserInfoData);
              }}
              color={"success"}
              variant="contained"
              sx={{ paddingX: "13px", width: "100px" }}
            >
              Save <Save sx={{ marginInlineStart: "10px" }} />
            </Button>
          </div>
        }
      />
      <ExpandableComponent
        title={"Edit Menu (Agent)"}
        Child={
          <div className="flex flex-col gap-4 mt-2 mb-36">
            {copyAgentInfoData?.map((element, i) => {
              return (
                <div>
                  <TextField
                    label={element.name}
                    placeholder="Type Value"
                    multiline
                    rows={2}
                    fullWidth
                    defaultValue={element.value}
                    onChange={(e) => {
                      copyAgentInfoData[i].value = e.target.value;
                    }}
                  />
                </div>
              );
            })}

            <Button
              onClick={() => {
                updateAgentData(copyAgentInfoData);
              }}
              color={"success"}
              variant="contained"
              sx={{ paddingX: "13px", width: "100px" }}
            >
              Save <Save sx={{ marginInlineStart: "10px" }} />
            </Button>
          </div>
        }
      />

      <ExpandableComponent
        title={"FAQS"}
        Child={
          <div className="flex flex-col gap-4 mt-2 mb-4">
          {copyFaqInfoData?.map((element, i) => {
            return (
              <div>
                <TextField
                  label={element.question}
                  placeholder="Type Value"
                  multiline
                  rows={2}
                  fullWidth
                  defaultValue={element.answer}
                  onChange={(e) => {
                    copyFaqInfoData[i].answer = e.target.value;
                  }}
                />
              </div>
            );
          })}

          <Button
            onClick={() => {
              updateFaqsData(copyFaqInfoData);
            }}
            color={"success"}
            variant="contained"
            sx={{ paddingX: "13px", width: "100px" }}
          >
            Save <Save sx={{ marginInlineStart: "10px" }} />
          </Button>
        </div>
        }
      />
    </div>
  );
}
